var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.getUserSymbol() === 'tk' || _vm.getUserSymbol() === 'sh' || _vm.getUserSymbol() === 'llpb')?_c('ion-icon',{staticClass:"clipboard-form-field-icon",attrs:{"name":"apps","color":_vm.getColorForClipboardIcon},on:{"click":_vm.showClipboard}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }